import type { ReactNode } from "react";
import { Badge } from "./badge";
import { cn } from "../../lib/utils";
import { getStatusToneClassName } from "../../lib/status-tone";

type StatusBadgeProps = {
  status: string;
  label?: ReactNode;
};

function formatStatus(status: string): string {
  if (!status) return "-";
  return status
    .replaceAll("_", " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const normalizedStatus = String(status).trim().toLowerCase();

  return (
    <Badge
      variant='secondary'
      className={cn(
        getStatusToneClassName(normalizedStatus),
      )}
    >
      {label ?? formatStatus(normalizedStatus)}
    </Badge>
  );
}
